import { call, put, takeLatest } from "redux-saga/effects";
import Swal from "sweetalert2";

import {
    FETCH_CANDIDATURES_REQUEST,
    fetchCandidaturesSuccess,
    fetchCandidaturesFail,

    FETCH_CANDIDATURE_REQUEST,
    fetchCandidatureSuccess,
    fetchCandidatureFail,

    FETCH_CANDIDATURES_BY_DEMANDE_REQUEST,
    fetchCandidaturesByDemandeSuccess,
    fetchCandidaturesByDemandeFail,

    FETCH_CANDIDATURES_BY_CANDIDAT_REQUEST,
    fetchCandidaturesByCandidatSuccess,
    fetchCandidaturesByCandidatFail,

    CREATE_CANDIDATURE_REQUEST,
    createCandidatureSuccess,
    createCandidatureFail,

    UPDATE_CANDIDATURE_REQUEST,
    updateCandidatureSuccess,
    updateCandidatureFail,

    ANNULER_CANDIDATURE_REQUEST,
    annulerCandidatureSuccess,
    annulerCandidatureFail,

    REJETER_CANDIDATURE_REQUEST,
    rejeterCandidatureSuccess,
    rejeterCandidatureFail,

    VALIDER_CANDIDATURE_REQUEST,
    validerCandidatureSuccess,
    validerCandidatureFail,

    DELETE_CANDIDATURE_REQUEST,
    deleteCandidatureSuccess,
    deleteCandidatureFail,

    setCandidaturesLoading,
} from "../actions/candidaturesActions";

import {
    API_BASE_URL,
    getRequest,
    postRequest,
    putRequest,
    deleteRequest,
} from "../../../api";

const getUid = () => sessionStorage.getItem("uid");
const getToken = () => sessionStorage.getItem("token");

// ===== Fetch all =====
export function* fetchCandidaturesSaga(action) {
    const isManagerScope = action?.payload?.scope === "manager";
    const url = isManagerScope
        ? `${API_BASE_URL}/api/candidatures/manager/mes-candidats`
        : `${API_BASE_URL}/api/candidatures`;
    const uid = getUid();
    const token = getToken();

    yield put(setCandidaturesLoading(true));
    try {
        const resp = yield call(getRequest, { url, uid, token });
        yield put(fetchCandidaturesSuccess(resp.data));
    } catch (e) {
        yield put(fetchCandidaturesFail(e.response?.data?.message || e.message));
    } finally {
        yield put(setCandidaturesLoading(false));
    }
}

// ===== Fetch one =====
export function* fetchCandidatureSaga(action) {
    const { id } = action.payload;
    const url = `${API_BASE_URL}/api/candidatures/${id}`;
    const uid = getUid();
    const token = getToken();

    yield put(setCandidaturesLoading(true));
    try {
        const resp = yield call(getRequest, { url, uid, token });
        yield put(fetchCandidatureSuccess(resp.data));
    } catch (e) {
        yield put(fetchCandidatureFail(e.response?.data?.message || e.message));
    } finally {
        yield put(setCandidaturesLoading(false));
    }
}

// ===== Fetch by demande =====
export function* fetchCandidaturesByDemandeSaga(action) {
    const { demandeId } = action.payload;
    const url = `${API_BASE_URL}/api/candidatures/by-demande/${demandeId}`;
    const uid = getUid();
    const token = getToken();

    yield put(setCandidaturesLoading(true));
    try {
        const resp = yield call(getRequest, { url, uid, token });
        yield put(fetchCandidaturesByDemandeSuccess(resp.data));
    } catch (e) {
        yield put(fetchCandidaturesByDemandeFail(e.response?.data?.message || e.message));
    } finally {
        yield put(setCandidaturesLoading(false));
    }
}

// ===== Fetch by candidat =====
export function* fetchCandidaturesByCandidatSaga(action) {
    const { candidatId } = action.payload;
    const url = `${API_BASE_URL}/api/candidatures/by-candidat/${candidatId}`;
    const uid = getUid();
    const token = getToken();

    yield put(setCandidaturesLoading(true));
    try {
        const resp = yield call(getRequest, { url, uid, token });
        yield put(fetchCandidaturesByCandidatSuccess(resp.data));
    } catch (e) {
        yield put(fetchCandidaturesByCandidatFail(e.response?.data?.message || e.message));
    } finally {
        yield put(setCandidaturesLoading(false));
    }
}

// ===== Create =====
export function* createCandidatureSaga(action) {
    const url = `${API_BASE_URL}/api/candidatures`;
    const uid = getUid();
    const token = getToken();

    yield put(setCandidaturesLoading(true));
    try {
        const resp = yield call(postRequest, {
            url,
            data: action.payload,
            uid,
            token,
        });

        yield put(createCandidatureSuccess(resp.data));

        yield call([Swal, Swal.fire], {
            icon: "success",
            text: "Candidature ajoutée",
            timer: 1400,
            showConfirmButton: false,
        });

        yield put({ type: FETCH_CANDIDATURES_REQUEST, payload: action.meta || {} });
    } catch (e) {
        const msg = e.response?.data?.message || "Erreur ajout candidature";
        yield put(createCandidatureFail(msg));
        yield call([Swal, Swal.fire], {
            icon: "error",
            text: msg,
            timer: 2200,
            showConfirmButton: false,
        });
    } finally {
        yield put(setCandidaturesLoading(false));
    }
}

// ===== Update =====
export function* updateCandidatureSaga(action) {
    const { id, payload } = action.payload;
    const url = `${API_BASE_URL}/api/candidatures/${id}`;
    const uid = getUid();
    const token = getToken();

    yield put(setCandidaturesLoading(true));
    try {
        const resp = yield call(putRequest, {
            url,
            data: payload,
            uid,
            token,
        });

        yield put(updateCandidatureSuccess(resp.data));

        yield call([Swal, Swal.fire], {
            icon: "success",
            text: "Candidature modifiée",
            timer: 1400,
            showConfirmButton: false,
        });

        yield put({ type: FETCH_CANDIDATURES_REQUEST, payload: action.meta || {} });
    } catch (e) {
        const msg = e.response?.data?.message || "Erreur modification candidature";
        yield put(updateCandidatureFail(msg));
        yield call([Swal, Swal.fire], {
            icon: "error",
            text: msg,
            timer: 2200,
            showConfirmButton: false,
        });
    } finally {
        yield put(setCandidaturesLoading(false));
    }
}

// ===== Annuler =====
export function* annulerCandidatureSaga(action) {
    const { id, motif } = action.payload;
    const url = `${API_BASE_URL}/api/candidatures/${id}/annuler`;
    const uid = getUid();
    const token = getToken();

    yield put(setCandidaturesLoading(true));
    try {
        const resp = yield call(putRequest, {
            url,
            data: { motif },
            uid,
            token,
        });

        yield put(annulerCandidatureSuccess(resp.data));

        yield call([Swal, Swal.fire], {
            icon: "success",
            text: "Candidature annulée",
            timer: 1400,
            showConfirmButton: false,
        });

        yield put({ type: FETCH_CANDIDATURES_REQUEST, payload: action.meta || {} });
    } catch (e) {
        const msg = e.response?.data?.message || "Erreur annulation candidature";
        yield put(annulerCandidatureFail(msg));
        yield call([Swal, Swal.fire], {
            icon: "error",
            text: msg,
            timer: 2200,
            showConfirmButton: false,
        });
    } finally {
        yield put(setCandidaturesLoading(false));
    }
}

// ===== Rejeter =====
export function* rejeterCandidatureSaga(action) {
    const { id, motif } = action.payload;
    const url = `${API_BASE_URL}/api/candidatures/${id}/rejeter`;
    const uid = getUid();
    const token = getToken();

    yield put(setCandidaturesLoading(true));
    try {
        const resp = yield call(putRequest, {
            url,
            data: { motif },
            uid,
            token,
        });

        yield put(rejeterCandidatureSuccess(resp.data));

        yield call([Swal, Swal.fire], {
            icon: "success",
            text: "Candidature rejetée",
            timer: 1400,
            showConfirmButton: false,
        });

        yield put({ type: FETCH_CANDIDATURES_REQUEST, payload: action.meta || {} });
    } catch (e) {
        const msg = e.response?.data?.message || "Erreur rejet candidature";
        yield put(rejeterCandidatureFail(msg));
        yield call([Swal, Swal.fire], {
            icon: "error",
            text: msg,
            timer: 2200,
            showConfirmButton: false,
        });
    } finally {
        yield put(setCandidaturesLoading(false));
    }
}

// ===== Valider =====
export function* validerCandidatureSaga(action) {
    const { id } = action.payload;
    const url = `${API_BASE_URL}/api/candidatures/${id}/valider`;
    const uid = getUid();
    const token = getToken();

    yield put(setCandidaturesLoading(true));
    try {
        const resp = yield call(putRequest, {
            url,
            data: {},
            uid,
            token,
        });

        yield put(validerCandidatureSuccess(resp.data));

        yield call([Swal, Swal.fire], {
            icon: "success",
            text: "Candidature validée",
            timer: 1400,
            showConfirmButton: false,
        });

        yield put({ type: FETCH_CANDIDATURES_REQUEST, payload: action.meta || {} });
    } catch (e) {
        const msg = e.response?.data?.message || "Erreur validation candidature";
        yield put(validerCandidatureFail(msg));
        yield call([Swal, Swal.fire], {
            icon: "error",
            text: msg,
            timer: 2200,
            showConfirmButton: false,
        });
    } finally {
        yield put(setCandidaturesLoading(false));
    }
}

// ===== Delete =====
export function* deleteCandidatureSaga(action) {
    const { id } = action.payload;
    const url = `${API_BASE_URL}/api/candidatures/${id}`;
    const uid = getUid();
    const token = getToken();

    yield put(setCandidaturesLoading(true));
    try {
        yield call(deleteRequest, { url, uid, token });
        yield put(deleteCandidatureSuccess(id));

        yield call([Swal, Swal.fire], {
            icon: "success",
            text: "Candidature supprimée",
            timer: 1400,
            showConfirmButton: false,
        });
    } catch (e) {
        const msg = e.response?.data?.message || "Erreur suppression candidature";
        yield put(deleteCandidatureFail(msg));
        yield call([Swal, Swal.fire], {
            icon: "error",
            text: msg,
            timer: 2200,
            showConfirmButton: false,
        });
    } finally {
        yield put(setCandidaturesLoading(false));
    }
}

